import { userDataRequest } from '../../lib/userDataRequest';
import compact from 'lodash-es/compact';

export const createCollection = (collection) => {
  const body = { title: collection.title };
  return userDataRequest('post', '/collections', {}, false, body);
};

export const getCollectionById = (collectionId) => {
  return userDataRequest('get', `/collections/${collectionId}`);
};

export const getImportedCollections = (collectionIds) => {
  const body = { collectionIds }
  return userDataRequest('post', '/collections/get', {}, false, body);
};

export const getCollectionsList = (params) => {
  return userDataRequest('get', '/collections', params);
};

export const updateCollection = (collection) => {
  const collectionId = collection.uuid;
  const body = {
    title: collection.title,
  };
  return userDataRequest(
    'patch',
    `/collections/${collectionId}`,
    {},
    false,
    body
  );
};
// method, path, params, authHeaders = false, data = {}, query
export const deleteCollection = (collection, params) => {
  const collectionId = collection.uuid;
  return userDataRequest('delete', `/collections/${collectionId}`, params);
};

export const addFeatureToCollections = (featureIds, collectionId) => {
  const body = { featureIds: compact(featureIds) };
  return userDataRequest(
    'patch',
    `/collections/${collectionId}/add/features`,
    {},
    false,
    body
  );
};

export const addFeaturesToCollections = (featureIds, collectionIds) => {
  const body = {
    featureIds,
    collectionIds,
  };
  return userDataRequest('patch', '/collections/add/features', {}, false, body);
};

export const removeFeaturesFromCollection = (featureIds, collectionId) => {
  const body = { featureIds: compact(featureIds) };
  return userDataRequest(
    'patch',
    `/collections/${collectionId}/remove/features`,
    {},
    false,
    body
  );
};

export const updateCollectionFeaturesVisibility = (
  collectionId,
  visibility
) => {
  const body = { visible: visibility };
  return userDataRequest(
    'patch',
    `/collections/${collectionId}/features/visible`,
    {},
    false,
    body
  );
};
